import { EntityGenerator, ObjectTypes } from "shared/src/types";
import { createCollidingBase } from "./bases";
import { ASTEROID_GRAV_MULTIPLIER, ASTEROID_RAD, ASTEROID_RAD_JITTER } from "../consts";
import { rgb } from "shared/src/utils";
import { HasGravity, Renderable } from "shared/src/ecs/components";

type AsteroidProps = {
  radius?: number;
  variant?: AsteroidVariant;
}

export enum AsteroidVariant {
  ROCKY,
  CHUNKY,
  POROUS,
  METALLIC,
  CARBON,
}

export const createAsteroid: EntityGenerator<AsteroidProps> = (world, pos, props) => {
  const radius = props?.radius ?? world.random.jitter(ASTEROID_RAD, ASTEROID_RAD_JITTER);
  const eid = createCollidingBase(world, pos, {
    objectType: ObjectTypes.ASTEROID,
    gravityStrength: radius * ASTEROID_GRAV_MULTIPLIER,
    radius,
  });
  Renderable.roughness[eid] = world.random.betweenFloat(0.45, 0.55);
  Renderable.pattern[eid] = world.random.betweenFloat(0.45, 0.55);
  Renderable.distortion[eid] = world.random.betweenFloat(0.35, 0.45);
  Renderable.col[eid] = rgb(119, 78, 0).ui32();
  Renderable.accentCol[eid] = rgb(12, 12, 12).ui32();

  if (typeof props?.variant !== 'undefined') {
    Renderable.variant[eid] = props.variant;
  } else {
    world.random.pickChance([
      {10: () => {
        Renderable.variant[eid] = AsteroidVariant.ROCKY;
      }},
      {10: () => {
        Renderable.variant[eid] = AsteroidVariant.CHUNKY;
      }},
      {10: () => {
        Renderable.variant[eid] = AsteroidVariant.POROUS;
      }},
      {20: () => {
        Renderable.variant[eid] = AsteroidVariant.METALLIC;
      }},
      {20: () => {
        Renderable.variant[eid] = AsteroidVariant.CARBON;
      }}
    ])();
  }

  const variant = Renderable.variant[eid];

  switch(variant) {
    case AsteroidVariant.CHUNKY: {
      Renderable.distortion[eid] = world.random.betweenFloat(0.45, 0.65);
      break;
    }
    case AsteroidVariant.POROUS: {
      Renderable.pattern[eid] = world.random.betweenFloat(0.55, 0.75);
      HasGravity.strength[eid] = HasGravity.strength[eid] * 0.8;
      break;
    }
    case AsteroidVariant.METALLIC: {
      Renderable.col[eid] = rgb(78, 78, 95).ui32();
      Renderable.accentCol[eid] = rgb(32, 12, 0).ui32();
      Renderable.roughness[eid] = world.random.betweenFloat(0.15, 0.25);
      Renderable.pattern[eid] = world.random.betweenFloat(0.25, 0.35);
      Renderable.distortion[eid] = world.random.betweenFloat(0.05, 0.25);
      HasGravity.strength[eid] = HasGravity.strength[eid] * 1.8;

      break;
    }
    case AsteroidVariant.CARBON: {
      Renderable.col[eid] = rgb(32, 32, 32).ui32();
      Renderable.accentCol[eid] = rgb(78, 78, 78).ui32();
      Renderable.pattern[eid] = world.random.betweenFloat(0.25, 0.35);
      HasGravity.strength[eid] = HasGravity.strength[eid] * 0.6;

      break;
    }
  }




  return eid;
}